import { getSalaries, getSalaryDetails } from '@/api/salary'
export default {
    state: {
        salaries: [],
        details: [],


    },

    mutations: {

        SET_SALARIES: (state, data) => {
            state.salaries = data
        },
        SET_SALARY_DETAILS: (state, data) => {
            state.details = [...data]
        }

    },

    actions: {
        getSalaries({ commit }) {
            commit('SET_TABLE_TEXT', true)
            commit("SET_PROGRESS_SHOW", true);
            return new Promise((resolve, reject) => {
                getSalaries().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    var data = response.data

                    for (var i = 0; i < data.length; i++) {
                        /**
                         * alary doesn't have any unique id
                         */

                        data[i].order = i
                    };
                    commit('SET_SALARIES', data)
                    commit('SET_TABLE_TEXT', false)
                    commit("SET_PROGRESS_SHOW", false);
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getSalaryDetails({ commit }, payload) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {
                getSalaryDetails(payload.relatedID, payload.type).then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_SALARY_DETAILS', data)
                    commit('SET_TABLE_TEXT', false)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        }


    }
}